import React, { Component } from "react";
import { SketchPicker } from "react-color";

export class CustomColorPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            useLineColor: "useLineColor" === props.color,
            lastColor: undefined
        };
    }

    handleToggle() {
        const newUseLineColor = !this.state.useLineColor;
        this.setState({ useLineColor: newUseLineColor });

        const newColor = newUseLineColor ? "useLineColor" : this.state.lastColor;
        this.props.onChange(newColor);
    }

    handleColorChange(color) {
        if ("useLineColor" !== color) {
            this.setState({ lastColor: color });
        }

        this.props.onChange(color);
    }

    render() {
        const { disableAlpha, presetColors, color, canUseLineColor } = this.props;
        const { useLineColor } = this.state;

        return (
            <div className="custom-color-popup">
                <div className="color-config-panel">
                    {canUseLineColor && (
                        <div className="form-group">
                            <div className="checkbox checkbox-primary">
                                <label className="control-label">
                                    <input
                                        type="checkbox"
                                        checked={useLineColor}
                                        onChange={() => this.handleToggle()}
                                    />
                                    <strong>Usar cor da linha</strong>
                                </label>
                            </div>
                            <p className="help-block text-muted">
                                {useLineColor
                                    ? "A cor será automaticamente definida pela cor da linha"
                                    : null}
                            </p>
                        </div>
                    )}
                    {!useLineColor && (
                        <div className="form-group">
                            <SketchPicker
                                color={color === "useLineColor" ? "#000000" : color}
                                onChange={(e) => this.handleColorChange(e)}
                                disableAlpha={disableAlpha}
                                presetColors={presetColors}
                                width="100%"
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/bussched/CustomColorPicker.js